import { faFilterCircleXmark, faList, faSearch, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdFirstPage, MdLastPage  } from "react-icons/md";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { usePersistentFilter } from "../hooks/usePersistentFilter.js";
import CustomSwitch from "../utilities/CustomSwitch.js";
import defaultImage from "../images/default.jpg";
import {
    EVENT_FORMAT_URL,
    EVENT_STATUS_URL,
    FAMILY_USERS,
    GET_REQUESTERS,
    GET_ALL_EVENT
} from "./ApiDetails.js";
function LeftContainerAdmin({ setFilteredEventDates }) {

    const [events, setEvents] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [requesters, setRequesters] = useState([]);
    const [familyMembers, setFamilyMembers] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [eventFormatFilters, setEventFormatFilters] = useState([]);
    const location = useLocation();

    const itemsPerPage = 6;
    const navigate = useNavigate();

    const [isWide, setIsWide] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1024px)");

        // Set initial value
        setIsWide(mediaQuery.matches);

        // Listener for changes
        const handler = (e) => {
            setIsWide(e.matches);
            if (!e.matches)
                setFilters(prev => ({
                    ...prev,
                    viewMode: "card"
                }));
        };
        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    //Custom hook
    const [filters, setFilters, resetFilters] = usePersistentFilter("EventFilters", {
        selectedStatuses: [],
        searchQuery: "",
        viewMode: "card",
        selectedDate: "",
        selectedEndDate: "",
        selectedRequester: "All",
        selectedFamilyMember: "All",
        selectedEventFormat: "All",
        sortBy: "Newest",
        onlyNotTakenVisit: false,
        mltEventFilter: false,
        currentPage: 1,
    });

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await axios.get(GET_ALL_EVENT);
                setEvents([...response.data.map(event => {
                    if (event.siteCode==="OFF") event.onelinerAddress = event.eventAddress.replace("\r\n", " ").replace("\r", " ").replace("\n", " "); else {
                        if ((event.cityName!=="") && (event.cityName!=="null") && (event.cityName!==null)) event.onelinerAddress = event.cityName;
                        if ((event.stateName!=="") && (event.stateName!=="null") && (event.stateName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.stateName;
                        if ((event.countryName!=="") && (event.countryName!=="null") && (event.countryName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.countryName;
                    }
                    return event;
                })]);

                const uniqueStatuses = (await axios.get(EVENT_STATUS_URL)).data;
                setStatuses(uniqueStatuses);

                // ✅ Select all statuses by default
                setFilters(prev => ({
                    ...prev,
                    selectedStatuses: uniqueStatuses
                }));

                const openEventDates = response.data
                    .filter(event => event.eventStatus === "Open event")
                    .map(event => new Date(event.eventDate));

                // setSelectedEventFormat("All");
                setFilteredEventDates(openEventDates);
            } catch (error) {
                console.error("Error fetching event data:", error);
            }
        };
        fetchEvents();
    }, [setFilteredEventDates]);

    useEffect(() => {
        const fetchEventFormat = async () => {
            try {
                const eventFormatResponse = await axios.get(EVENT_FORMAT_URL);
                setEventFormatFilters(eventFormatResponse.data);
            } catch (error) {
                console.error("Error fetching eventFormat data:", error);
            }
        };

        fetchEventFormat();
    }, []);

    useEffect(() => {
        const fetchRequesters = async () => {
            try {
                const response = await axios.get(GET_REQUESTERS);
                setRequesters(response.data);
            } catch (error) {
                console.error("Error fetching requesters:", error);
            }
        };

        fetchRequesters();
    }, []);

    useEffect(() => {
        const fetchFamilyMembers = async () => {
            try {
                const response = await axios.get(FAMILY_USERS);
                setFamilyMembers(response.data);
            } catch (error) {
                console.error("Error fetching family members:", error);
            }
        };

        fetchFamilyMembers();
    }, []);

    const handleStatusClick = (status) => {
        setFilters((prevFilters) => {
            const alreadySelected = prevFilters.selectedStatuses.includes(status);
            const updatedStatuses = alreadySelected
                ? prevFilters.selectedStatuses.filter((s) => s !== status)
                : [...prevFilters.selectedStatuses, status];
            return {
                ...prevFilters,
                selectedStatuses: updatedStatuses,
                currentPage: 1
            };
        });
    };

    const handleRequesterChange = (e) => {
        setFilters({ ...filters, selectedRequester: e.target.value, currentPage: 1 })
    };

    const handleEventFormatChange = (e) => {
        setFilters({ ...filters, selectedEventFormat: e.target.value, currentPage: 1 })
    };

    const handleFamilyMemberChange = (e) => {
        setFilters({ ...filters, selectedFamilyMember: e.target.value, currentPage: 1 })
    };

    const handleOnlyNotTakenVisitChange = (e) => {
        setFilters({ ...filters, onlyNotTakenVisit: e.target.checked, currentPage: 1 });
    };
    const handleMLTEventToggle = () => {
        setFilters({ ...filters, mltEventFilter: !filters.mltEventFilter, currentPage: 1 })
    };

    const handleResetFilters = () => {
        resetFilters({ selectedStatuses: statuses });
    };

    const isDateInRange = (
        eventDate,
        eventEndDate,
        selectedDate,
        selectedEndDate
    ) => {
        const eventStart = new Date(eventDate);
        const eventEnd = new Date(eventEndDate || eventDate);

        const selectedStart = selectedDate ? new Date(selectedDate) : null;
        const selectedEnd = selectedEndDate ? new Date(selectedEndDate) : null;

        return (
            (!selectedStart || eventStart >= selectedStart) &&
            (!selectedEnd || eventEnd <= selectedEnd)
        );
    };

    useEffect(() => {
        if (events) {
            const filteredEventsData = events.filter((event) => {
                const isMltEvent = event.mltEvent === true;
                if (filters.mltEventFilter && !isMltEvent) {
                    return false;
                }
                if (!filters.mltEventFilter && isMltEvent) {
                    return false;
                }
                const matchesStatus =
                    filters.selectedStatuses.length > 0 &&
                    filters.selectedStatuses.includes(event.eventStatus);

                const matchesSearchQuery =
                    filters.searchQuery === "" || filters.searchQuery === undefined ||
                    event.siteCode.toLowerCase().includes(filters.searchQuery.trim().toLowerCase()) ||
                    event.eventTitle.toLowerCase().includes(filters.searchQuery.trim().toLowerCase()) ||
                    event.eventVenueName.toLowerCase().includes(filters.searchQuery.trim().toLowerCase());

                const matchesDate =
                    (filters.selectedDate === "" && filters.selectedEndDate === "") ||
                    isDateInRange(
                        event.eventDate,
                        event.eventEndDate,
                        filters.selectedDate,
                        filters.selectedEndDate
                    );

                const matchesRequester =
                    filters.selectedRequester === "All" || event.requestedBy === filters.selectedRequester;

                const matchesFamilyMember =
                    filters.selectedFamilyMember === "All" ||
                    event.nameOfMem
                        .split(",")
                        .map((name) => name.trim())
                        .includes(filters.selectedFamilyMember);

                const matchesOnlyNotTakenVisit =
                    !filters.onlyNotTakenVisit ||
                    (event.nameOfMem === "" && ['Open event', 'Attendance confirmed'].includes(event.eventStatus) && new Date(event.eventEndDate) >= new Date(Date.now()))

                const matchesEventFormat =
                    filters.selectedEventFormat === "All" || event.eventFormat === filters.selectedEventFormat;

                return (
                    matchesEventFormat &&
                    matchesStatus &&
                    matchesSearchQuery &&
                    matchesDate &&
                    matchesRequester &&
                    matchesFamilyMember &&
                    matchesOnlyNotTakenVisit
                );
            });

            const filteredDates = filteredEventsData.map((event) => ({
                eventDate: event.eventDate,
                eventEndDate: event.eventEndDate,
                createdDate: event.createdDate,
                eventStatus: event.eventStatus,
                eventTitle: event.eventTitle,
                cityName: event.cityName,         // Include city name
                stateName: event.stateName,       // Include state name
                region: event.region,             // Include region
                countryName: event.countryName,   // Include country namec
                requestedBy: event.requestedBy,   // Include who requested the event
                coverImage: event.coverImage      // Include event cover image if needed
            }));

            setFilteredEventDates(filteredDates);
            setFilteredEvents(filteredEventsData);
        }
    }, [events, filters, statuses, familyMembers]);

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        if (filters.sortBy === "Newest") {
            return new Date(b.eventDate) - new Date(a.eventDate);
        } else if (filters.sortBy === "Oldest") {
            return new Date(a.eventDate) - new Date(b.eventDate);
        } else if (filters.sortBy === "A to Z") {
            return a.eventTitle.localeCompare(b.eventTitle);
        } else if (filters.sortBy === "Z to A") {
            return b.eventTitle.localeCompare(a.eventTitle);
        }
        return 0;
    });

    const totalPages = Math.ceil(sortedEvents.length / itemsPerPage);
    const currentEvents = sortedEvents.slice(
        (filters.currentPage - 1) * itemsPerPage,
        filters.currentPage * itemsPerPage
    );

    const handlePageClick = (pageNumber) => {
        setFilters({ ...filters, currentPage: pageNumber })
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const isMobile = window.innerWidth <= 400;
        const maxPageNumbersToShow = isMobile ? 2 : 5;

        let startPage = Math.max(1, filters.currentPage - Math.floor(maxPageNumbersToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }

        return pageNumbers;
    };

    return (
        <div
            className="leftcontainer d-flex flex-column progress-bar bg-white rounded-end"
            aria-valuenow="60"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ minHeight: "500px" }}
        >
            <div className="leftsearchbox adminPageSearchDateSpacing">
              <div className="container-fluid d-flex align-items-center">
                <div className="status-buttons mb-0">
                  <h6 className="calendar-headerh6 mr-2">Status</h6>
                        {statuses.map((status) => (
                            <>
                                <div
                                    key={status}
                                    className={`status-button ${filters.selectedStatuses.includes(status) ? "selected" : ""}`}
                                    onClick={() => handleStatusClick(status)}
                                >
                                    <span>{status}</span>
                                </div>
                            </>
                        ))}
                </div>
                {isWide ? (
                    <div className="col-md-1">
                            <FontAwesomeIcon
                                icon={filters.viewMode === "card" ? faList : faTh}
                                onClick={() => setFilters({ ...filters, viewMode: filters.viewMode === "card" ? "list" : "card" })}
                                style={{ cursor: 'pointer', fontSize: '20px', marginTop: '5px' }}
                            />
                    </div>
                ) : ("")}
              </div>
                <br/>
                <div className="container-fluid align-items-center">
                    <div className="row adminPageSearchDateSpacing">
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <label
                                    htmlFor="searchInput"
                                    className="input-group-text input-group-text-custom"
                                >
                                    Search
                                </label>
                                <div className="adminStatusSearchColumn">
                                    <input
                                        type="text"
                                        className={`form-control-custom rounded form-control`}
                                        id="searchInput"
                                        placeholder="Type a keyword"
                                        value={filters.searchQuery}
                                        onChange={(e) =>
                                            setFilters({ ...filters, searchQuery: e.target.value, currentPage: 1 })
                                        }
                                        style={{ paddingRight: "30px" }}
                                    />
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        className="search-icon-custom"
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            cursor: "pointer",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-center">
                            <label
                                htmlFor="dateInput"
                                className="input-group-text input-group-text-custom"
                                style={{
                                    whiteSpace: "nowrap",
                                    // marginLeft: '-105px'
                                }}
                            >
                                Date Interval
                            </label>
                            <div
                                style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                className="requestorMainPageDateInterval"
                            >
                                <input
                                    type="date"
                                    className="form-control-custom rounded form-control selectDateInput"
                                    id="dateInput"
                                    value={filters.selectedDate}
                                    onChange={(e) => setFilters({ ...filters, selectedDate: e.target.value, currentPage: 1 })}
                                />
                                <span style={{ fontWeight: "bold" }}>TO</span>
                                <input
                                    type="date"
                                    className="form-control-custom rounded form-control selectDateInput"
                                    id="dateInput1"
                                    value={filters.selectedEndDate}
                                    onChange={(e) => setFilters({ ...filters, selectedEndDate: e.target.value, currentPage: 1 })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 align-items-center adminPageSearchDateSpacing">
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <label
                                    className="input-group-text input-group-text-custom"
                                    htmlFor="requester"
                                >
                                    Requester
                                </label>
                                <select
                                    className="form-control-custom rounded form-select"
                                    aria-label="Requester"
                                    id="requester"
                                    value={filters.selectedRequester}
                                    onChange={handleRequesterChange}
                                >
                                    <option value="All">All</option>
                                    {requesters.map((requester, index) => (
                                        // TODO: Switch to user.ID if possible.
                                        <option key={index} value={requester.fullname}>
                                            {requester.fullname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <label
                                    className="input-group-text input-group-text-custom "
                                    htmlFor="familyMember"
                                >
                                    Family Member
                                </label>
                                <select
                                    className="form-control-custom rounded form-select"
                                    aria-label="Family Member"
                                    id="familyMember"
                                    value={filters.selectedFamilyMember}
                                    onChange={handleFamilyMemberChange}
                                >
                                    <option value="All">All</option>
                                    {familyMembers.map((familyMember, index) => (
                                        // TODO: Switch to user.ID if possible.
                                        <option key={index} value={familyMember.fullname}>
                                            {familyMember.fullname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                <label
                                    className="input-group-text input-group-text-custom"
                                    htmlFor="sortBy"
                                >
                                    Sort By
                                </label>
                                <select
                                    className="form-control-custom rounded form-select "
                                    aria-label="Sort By"
                                    id="sortBy"
                                    value={filters.sortBy}
                                    onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}
                                >
                                    <option value="Newest">Newest</option>
                                    <option value="Oldest">Oldest</option>
                                    <option value="A to Z">A to Z</option>
                                    <option value="Z to A">Z to A</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 align-items-center adminPageSearchDateSpacing">
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                {/* need */}
                                    <label
                                        htmlFor="eventFormat"
                                        className="input-group-text input-group-text-custom"
                                        style={{
                                            whiteSpace: "nowrap",
                                            // marginLeft: '-105px'
                                        }}
                                    >
                                        EVENT FORMAT
                                    </label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        style={{ width: "130px", }}
                                        aria-label="Event Format"
                                        id="eventFormat"
                                        value={filters.selectedEventFormat}
                                        onChange={handleEventFormatChange}
                                    >
                                        <option value="All">All</option>
                                        {eventFormatFilters.length > 0 &&
                                            eventFormatFilters.map((formatName, index) => (
                                                <option key={index} value={formatName}>
                                                    {formatName}
                                                </option>
                                            ))}
                                    </select>
                        </div>
                        </div>
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="onlyNotTakenVisit"
                                    >
                                        Needs Family Members
                                    </label>
                                    <CustomSwitch
                                        id="onlyNotTakenVisit"
                                        checked={filters.onlyNotTakenVisit}
                                        onChange={handleOnlyNotTakenVisitChange}
                                    />
                        </div>
                        </div>
                        <div className="col-md-4">
                            <div className="input-group mb-0">
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="onlyNotTakenVisit"
                                        style={{
                                            fontWeight: "400",
                                            color: "darkblue",
                                            fontSize: "13px",
                                            // whiteSpace: "nowrap",
                                            textTransform: "uppercase"

                                        }}
                                    >
                                        Family Members
                                    </label>
                                    <CustomSwitch
                                        id="onlyNotTakenVisits"
                                        checked={filters.mltEventFilter}
                                        onChange={handleMLTEventToggle}
                                    />
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="onlyNotTakenVisits"
                                        style={{
                                            fontWeight: "400",
                                            color: "darkblue",
                                            fontSize: "12px",
                                            whiteSpace: "nowrap",
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        MLT
                                    </label>
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="resetFilter">
                                        RESET
                                    </label>
                                    <FontAwesomeIcon
                                        id="resetFilter"
                                        icon={faFilterCircleXmark}
                                        onClick={() => handleResetFilters()}
                                        style={{ cursor: 'pointer', fontSize: '20px' }}
                                    />
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="listitems">
                <div className="row card-group text-wrap text-start m-2 flex-wrap">
                    {currentEvents.map((event) => (
                        <div key={event.id} className={filters.viewMode === 'card' ? 'col-md-4 p-2' : 'list-group'}>
                            <div className="card-event" onClick={() => { const url = `/GetDetail/${event.eventId}`; navigate(url, { state: { from: location.pathname } }); }}>
                                <div className={`card rounded ${filters.viewMode === 'card' ? 'align-items-stretch' : 'list-group-item'} list-card`}>
                                    <div className={filters.viewMode === 'card' ? "card-img-container" : "col-md-1 d-flex justify-content-between align-items-start d-none"} >
                                        {event.coverImage
                                            ? <img
                                                className={filters.viewMode === 'card' ? "card-img-top-custom card-img-top rounded" : "d-flex justify-content-between align-items-start"}
                                                src={event.coverImage ?? defaultImage}
                                                alt={event.eventTitle} />
                                            : <div className='card-noimg-text'>
                                                <span className='line-clamp-3'>{event.eventTitle}</span>
                                            </div>}
                                    </div>
                                    <div className={`card-body-custom card-body ${filters.viewMode === 'list' ? 'list-body col-md-8' : ''}`}>
                                        <h6 className={filters.viewMode === 'list' ? 'list-header-custom line-clamp-2' : 'card-header-custom line-clamp-2'} title={event.eventTitle}>
                                            {event.eventTitle}
                                        </h6>
                                        <div className={filters.viewMode === 'list' ? 'list-text-custom' : 'event-card-text-custom'}>
                                            {event.mltEvent
                                                ? event.mltGuests.filter(guest => guest.status === 'Confirmed').length > 0 && (
                                                    <>
                                                        with <b>{event.mltGuests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                    </>
                                                )
                                                : event.familyGuests.filter(guest => guest.status === 'Confirmed').length > 0 && (
                                                    <>
                                                        with <b>{event.familyGuests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                    </>
                                                )}


                                            {((event.eventStatus === "Open event") && (
                                               (!event.mltEvent && (event.familyGuests.filter(guest => guest.status === 'Confirmed').length < event.familyNum))
                                            || (event.mltEvent && (event.mltGuests.filter(guest => guest.status === 'Confirmed').length < event.mltNum))
                                            )) && (event.mltEvent 
                                                ? <>
                                                    <div>Still accepting MLT members <b>{event.mltGuests.filter(guest => guest.status === 'Confirmed').length} out of {event.mltNum}</b></div>
                                                </>
                                                : <>
                                                    <div>Still accepting Family members <b>{event.familyGuests.filter(guest => guest.status === 'Confirmed').length} out of {event.familyNum}</b></div>
                                                </>
                                            )}
                                            <div>
                                                <b>
                                                    {new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} to{" "}
                                                    {new Date(event.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} •{" "}
                                                    {event.onelinerAddress}
                                                </b>
                                            </div>
                                            <br />
                                            <span>
                                                Created by {event.requestedBy} on{" "}
                                                {new Date(event.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        {filters.viewMode === "card" ?
                                            <div className='card-footer card-footer-custom'>
                                                <Link
                                                    to={`/GetDetail/${event.eventId}`}
                                                    className={`card-footer-button btn rounded-pill ${event.eventStatus}`}
                                                >
                                                    {event.eventStatus.toUpperCase()}
                                                </Link>
                                                <span className="float-right-custom adminHomeEventFooterActionButtons">
                                                    <Link
                                                        className="card-footer-button-right btn"
                                                        to={`/GetDetailAdmin/guest/${event.eventId}`}
                                                    >
                                                        ✖️
                                                    </Link>
                                                    <Link
                                                        className="card-footer-button-right btn"
                                                        to={`/GetDetailAdmin/guest/${event.eventId}`}
                                                    >
                                                        ✔️
                                                    </Link>
                                                </span>
                                            </div>
                                            :
                                            <div className='card-footer card-footer-custom event-btn col-md-4'>
                                                <Link
                                                    to={`/GetDetail/${event.eventId}`}
                                                    className={`card-footer-button btn rounded-pill ${event.eventStatus}`}
                                                >
                                                    {event.eventStatus.toUpperCase()}
                                                </Link>
                                                <span className="float-right-custom adminHomeEventFooterActionButtons">
                                                    <Link
                                                        className="card-footer-button-right btn"
                                                        to={`/GetDetailAdmin/guest/${event.eventId}`}
                                                    >
                                                        ✖️
                                                    </Link>
                                                    <Link
                                                        className="card-footer-button-right btn"
                                                        to={`/GetDetailAdmin/guest/${event.eventId}`}
                                                    >
                                                        ✔️
                                                    </Link>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="paging align-items-center" style={{userSelect: 'none'}}>
                <span>
                    {(totalPages>0) && (<>{(filters.currentPage - 1) * itemsPerPage + 1}-{Math.min(filters.currentPage * itemsPerPage, sortedEvents.length)} OF{" "}</>)}
                    {sortedEvents.length} ELEMENTS &nbsp;&nbsp;
                </span>
                <nav>
                    <ul className="pagination justify-content-end" style={{ marginBottom: "17px", cursor: "pointer" }}>
                        <li className={`page-item ${((totalPages===0) || filters.currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdFirstPage /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || filters.currentPage === 1) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(filters.currentPage - 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdKeyboardArrowLeft /></span>
                        </li>
                        {getPageNumbers().map((number) => (
                            <li key={number} className={`page-item ${filters.currentPage === number ? "active" : ""}`}>
                                <span className="page-link" onClick={() => handlePageClick(number)} style={{ fontSize: "12px", padding: "4px 8px" }}>{number}</span>
                            </li>
                        ))}
                        <li className={`page-item ${((totalPages===0) || filters.currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(filters.currentPage + 1)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdOutlineKeyboardArrowRight /></span>
                        </li>
                        <li className={`page-item ${((totalPages===0) || filters.currentPage === totalPages) ? "disabled" : ""}`}>
                            <span className="page-link" onClick={() => handlePageClick(totalPages)} style={{ fontSize: "12px", padding: "4px 8px" }}><MdLastPage /></span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default LeftContainerAdmin;